import { FormTemplateQuestionFieldOptionsValidityHintEnum } from 'graphql-common';
import getValidityHintOptions from 'components/FormTemplateBuilder/utils/getValidityHintOptions';

export default function getValidityHintOptionByValue(
  hint: FormTemplateQuestionFieldOptionsValidityHintEnum,
) {
  return getValidityHintOptions().find(({ value }) => value === hint);
}
